var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.265 6a.74.74 0 0 0-.519.215L5.721 16.241l-.347 1.385 1.386-.347L16.785 7.254A.734.734 0 0 0 16.265 6m-1.933-1.2a2.735 2.735 0 1 1 3.867 3.868L7.978 18.89a1 1 0 0 1-.465.263l-3.27.818a1 1 0 0 1-1.213-1.212l.818-3.271a1 1 0 0 1 .263-.465zM11 19a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})));
export default SvgIcSEdit;